import { render, staticRenderFns } from "./OrderCategoryModal.vue?vue&type=template&id=fbba9bc6&scoped=true"
import script from "./OrderCategoryModal.vue?vue&type=script&lang=js"
export * from "./OrderCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./OrderCategoryModal.vue?vue&type=style&index=0&id=fbba9bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbba9bc6",
  null
  
)

export default component.exports